export default "__VITE_ASSET__YLtUgDzY__"